import o from "./aiCancelDialog.ce.vue2.js";
import t from "./aiCancelDialog.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const e = /* @__PURE__ */ r(o, [["styles", [t]]]);
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-cancel-dialog/aiCancelDialog.ce.vue.js
// module id = 1189
// module chunks = 67